import React from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableItem({ item, index }) {
  const safeId = item?.capability?._id;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: safeId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || "transform 200ms ease",
  };

  return (
    <div
      ref={setNodeRef}
      className={`admin-order-item${item.enabled ? " is-on" : ""}`}
      style={style}
      {...attributes}
      {...listeners}
    >
      <span className="admin-order-item__index">{String(index + 1).padStart(2, "0")}</span>
      <span className="admin-order-item__copy">
        <strong>{item?.capability?.value}</strong>
        <small>{item.enabled ? "Shown in the menu" : "Hidden"}</small>
      </span>
      <i className="bi bi-grip-vertical" aria-hidden="true" />
    </div>
  );
}

export default function ReorderDragger({ items, onChange }) {
  const [list, setList] = React.useState(items || []);
  const [isChanged, setIsChanged] = React.useState(false);

  React.useEffect(() => {
    setList(items || []);
    setIsChanged(false);
  }, [items]);

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = list.findIndex((i) => i?.capability._id === active.id);
    const newIndex = list.findIndex((i) => i?.capability?._id === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    const newList = arrayMove(list, oldIndex, newIndex);
    setList(newList);
    setIsChanged(true);
  };

  const handleSave = () => {
    const updated = list.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
    onChange && onChange(updated);
    setIsChanged(false);
  };

  // if (!list.length) {
  //   return <p>Loading...</p>; // safety check
  // }

  return (
    <div className="admin-block">
      <p className="admin-order-lead">
        Drag a row to change its place. The new order is saved only after you confirm it.
      </p>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={list.map((i) => i?.capability?._id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="admin-order-list">
            {list.map((item, index) => (
              <SortableItem key={item?.capability?._id} item={item} index={index} />
            ))}
          </div>
        </SortableContext>
      </DndContext>

      {isChanged && (
        <div className="settings-actions">
          <button type="button" className="settings-btn settings-btn--primary" onClick={handleSave}>
            Save order
          </button>
        </div>
      )}
    </div>
  );
}
